module.exports = __webpack_public_path__ + "static/media/ANDROS DELUXE II PHONOSTAGE.27d6547a.png";